import React from "react";
import { Card, Chip } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import { useWatch } from "react-hook-form";
import { FormHidden } from "../../../../components/Forms/FormHidden";
import { InitializeArrangementVariant } from "./General/InitializeArrangementVariant";
import { SupplementaryArrangement } from "./General/SupplementaryArrangement";
import { PreDiningArrangement } from "./General/PreDiningArrangement";
import { RegularArrangement } from "./General/RegularArrangement";

export type ArrangementVariant = undefined | "regular" | "supplementary" | "pre-dining";

export default function General() {
  const variant: undefined | "regular" | "supplementary" | "pre-dining" = useWatch({ name: "variant" });

  return (
    <>
      <Card sx={{ mb: 2 }}>
        <CardBody>
          {variant != null ? (
            <>
              <FormHidden name={"variant"} value={variant} />
              <Chip label={variant} /> arrangement variant
            </>
          ) : (
            <InitializeArrangementVariant />
          )}
        </CardBody>
      </Card>
      <SupplementaryArrangement variant={variant} />
      <PreDiningArrangement variant={variant} />
      <RegularArrangement variant={variant} />
    </>
  );
}
